// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1SEgl","bigColWidth":"Table_bigColWidth__28Rhz","biggerColWidth":"Table_biggerColWidth__2kzev","row":"Table_row__qcdLg","col":"Table_col__I0ChA"};